import { FunctionComponent } from 'react';
import styles from './SocialBar.module.css';
import discord from './img/discord.svg';
import reddit from './img/reddit.svg';
import instagram from './img/instagram.svg';
import x from './img/x.svg';
import tiktok from './img/tiktok.svg';

interface Social {
  label: string;
  icon: string;
  href: string;
}

// Discord deep-link falls back to the web client if the app isn't installed —
// a plain https link does that automatically, so no JS handler is needed.
const SOCIALS: Social[] = [
  {
    label: 'Discord',
    icon: discord,
    href: 'https://discord.com/channels/1080935105012432948/1080935105511563458',
  },
  { label: 'TikTok', icon: tiktok, href: 'https://www.tiktok.com/@crystallinerift' },
  { label: 'Instagram', icon: instagram, href: 'https://www.instagram.com/crystallinerift/' },
  { label: 'X', icon: x, href: 'https://x.com/crystallinerift' },
  { label: 'Reddit', icon: reddit, href: 'https://www.reddit.com/r/CrystallineRift/' },
];

const SocialBar: FunctionComponent = () => (
  <nav className={styles.bar} aria-label="Crystalline Rift social links">
    {SOCIALS.map(({ label, icon, href }) => (
      <a
        key={label}
        href={href}
        className={styles.button}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        title={label}
      >
        <img src={icon} className={styles.icon} alt="" aria-hidden="true" />
      </a>
    ))}
  </nav>
);

export default SocialBar;
